import { render, staticRenderFns } from "./guest-invite.vue?vue&type=template&id=46815604&"
import script from "./guest-invite.vue?vue&type=script&lang=js&"
export * from "./guest-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports